var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7509 2.45001C11.4509 1.86001 12.5809 1.86001 13.2609 2.45001L14.8409 3.80001C15.1409 4.05001 15.7109 4.26001 16.1109 4.26001H17.8109C18.8709 4.26001 19.7409 5.13001 19.7409 6.19001V7.89001C19.7409 8.29001 19.9509 8.85001 20.2009 9.15001L21.5509 10.73C22.1409 11.43 22.1409 12.56 21.5509 13.24L20.2009 14.82C19.9509 15.12 19.7409 15.68 19.7409 16.08V17.78C19.7409 18.84 18.8709 19.71 17.8109 19.71H16.1109C15.7109 19.71 15.1509 19.92 14.8509 20.17L13.2709 21.52C12.5709 22.11 11.4409 22.11 10.7609 21.52L9.18086 20.17C8.88086 19.92 8.31086 19.71 7.92086 19.71H6.17086C5.11086 19.71 4.24086 18.84 4.24086 17.78V16.07C4.24086 15.68 4.04086 15.11 3.79086 14.82L2.44086 13.23C1.86086 12.54 1.86086 11.42 2.44086 10.73L3.79086 9.14001C4.04086 8.84001 4.24086 8.28001 4.24086 7.89001V6.20001C4.24086 5.14001 5.11086 4.27001 6.17086 4.27001H7.90086C8.30086 4.27001 8.86086 4.06001 9.16086 3.81001L10.7509 2.45001Z",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.13V12.96",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 16H12.0031",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.200252350bb75964d053b2e0b924dd52.svg";
export { ForwardRef as ReactComponent };